export default __webpack_public_path__ + "static/media/pivot-trading-partner.6c02dc41.svg";